import cn from 'classnames'
import * as React from 'react'

import styles from './stepper.module.scss'
import Button from '../../../../components/button'
import { FormattedMessage } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedo, faAngleLeft } from '@fortawesome/pro-light-svg-icons'
import { removeTokenAndOrgId } from '../../../..'

const signupsSteps = [
  {
    value: <FormattedMessage defaultMessage="Ditt företag" id="sync-bank.components.step-1" />,
    key: 1,
  },
  {
    value: <FormattedMessage defaultMessage="Synkar" id="sync-bank.components.step-2" />,
    key: 2,
  },
  {
    value: <FormattedMessage defaultMessage="Klart" id="sync-bank.components.step-4" />,
    key: 3,
  },
]

interface IStepperProps {
  nrOfSteps: number
  activeStep: number
  handleGoBack: (newNumber: number) => void
  step: number
}

const Stepper = ({ activeStep, handleGoBack, step }: IStepperProps) => (
  <div className={styles.stepperWrapper}>
    <div className={styles.stepperContent}>
      <div className={styles.buttonWrapper}>
        <Button
          className={styles.button}
          onClick={() => {
            removeTokenAndOrgId()
            window.location.reload()
          }}
          variant="link"
        >
          <i>
            <FontAwesomeIcon icon={faRedo} />{' '}
          </i>
          <FormattedMessage defaultMessage="Börja om" id="sync-bankcomponents.stepper-restart" />
        </Button>
        <Button
          className={styles.button}
          onClick={() => handleGoBack(step === 7 ? step - 2 : step === 5 ? step - 4 : step - 1)}
          variant="link"
        >
          <i>
            <FontAwesomeIcon icon={faAngleLeft} />{' '}
          </i>
          <FormattedMessage defaultMessage="Gå tillbaks" id="sync-bankcomponents.stepper-back" />
        </Button>
      </div>

      <div className={styles.stepper}>
        {signupsSteps.map((s, i) => (
          <div className={styles.stepWrapper} key={s.key}>
            <div className={cn(styles.step, activeStep === i && styles.active)} />
            <p>{s.value}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default Stepper
